export const TipoBeneficioEnum = Object.freeze({
  PLANO_DE_SAUDE: 1,
  PLANO_DENTAL: 2,
  VALE_ALIMENTACAO: 3,
  VALE_REFEICAO: 4,
  VALE_TRANSPORTE: 5,
});
